import Parent from "parentjs/controllers/scroll_down_controller.js";
export default Parent;
